<template>
  <div>
    <div class="topsearch-container">
      <a-form :model="MIXINTopSearchParams" v-bind="MIXINTopSearchFormSetting">
        <a-row>
          <a-col v-bind="MIXINDefaultTopSearchSigns">
            <a-form-item label="奖品类型">
              <a-input v-model="MIXINTopSearchParams.name" allowClear placeholder="输入奖品类型" />
            </a-form-item>
          </a-col>
          <a-col v-bind="MIXINDefaultTopSearchSigns" class="topsearch-submit">
            <a-button type="primary" icon="search" @click="handleTopSearchSubmit">查询</a-button>
            <a-button type="primary" icon="delete" ghost @click="handleTopSearchClear">清空</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-divider :dashed="true" class="divider--notop" />
    <div>
      <a-button
        type="primary"
        icon="plus-circle"
        class="activity-add-btn"
        @click="handleOpenDialog(null, 1)">
        添加类型
      </a-button>
      <a-table
        row-key="id"
        v-bind="MIXINTableSetting"
        @change="handleTableChange">
        <template slot="operator" slot-scope="text, record">
          <a-button type="link" size="small" @click="handleOpenDialog(record, 2)">编辑</a-button>
          <a-popconfirm
            title="您确认删除吗？"
            ok-text="删除"
            cancel-text="取消"
            @confirm="confirmDelete(record)">
            <a-button type="link" size="small">删除</a-button>
          </a-popconfirm>
        </template>
      </a-table>
    </div>
    <a-modal
      :title="getDialogTitle"
      :visible="dialogVisible"
      :confirm-loading="dialogConfirmLoading"
      @ok="handleOk"
      @cancel="dialogVisible = false">
      <a-form-model
        ref="dialogForm"
        :model="dialogForm"
        :rules="dialogFormRules"
        v-bind="dialogSetting">
        <a-form-model-item label="类型名称" prop="name">
          <a-input v-model="dialogForm.name" placeholder="请输入类型名称"/>
        </a-form-model-item>
        <a-form-model-item label="类型描述" prop="detail">
          <a-input v-model="dialogForm.detail" type="textarea" placeholder="请输入类型描述" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import _ from 'lodash'
import api from '@/api/'
import moment from 'moment'
import { ReuseMixin } from '../mixins/reuse'

const tableColumns = [
  { title: 'ID', dataIndex: 'id' },
  { title: '类型名称', dataIndex: 'name' },
  { title: '类型描述', dataIndex: 'detail' },
  { title: '添加时间', dataIndex: 'created_at',
    customRender: text => text ? moment.unix(Number(text)).format('YYYY-MM-DD HH:mm:ss') : '--' },
  { title: '更新时间', dataIndex: 'updated_at',
    customRender: text => text ? moment.unix(Number(text)).format('YYYY-MM-DD HH:mm:ss') : '--' },
  { title: '操作', dataIndex: 'operator', width: 160,
    scopedSlots: { customRender: 'operator' }
  }
]

export default {
  name: 'ActivityPrizeType',
  mixins: [ReuseMixin],
  data() {
    return {
      dialogVisible: false,
      dialogConfirmLoading: false,
      pitchOnDialogType: 1,
      dialogForm: { name: '', detail: '' },
      dialogFormRules: {
        name: [
          { required: true, message: '请输入奖品类型', trigger: 'blur' },
          { min: 1, max: 20, message: '不超过20个字', trigger: 'blur' }
        ],
        detail: [
          { required: true, message: '请输入类型描述', trigger: 'blur' },
          { min: 1, max: 50, message: '不超过50个字', trigger: 'blur' }
        ]
      },
      dialogSetting: { labelCol: { span: 5 }, wrapperCol: { span: 17 } }
    }
  },
  computed: {
    getDialogTitle() {
      switch (this.pitchOnDialogType) {
        case 1:
          return '新增类型'
        case 2:
          return '编辑类型'
        default:
          return ''
      }
    }
  },
  watch: {
    dialogVisible(visible) {
      if (!visible) {
        this.dialogForm = _.cloneDeep({ name: '', detail: '' })
        this.$refs.dialogForm.clearValidate()
      }
    }
  },
  methods: {
    // type: 1 => 新增 2 => 编辑
    handleOpenDialog(record, type) {
      this.pitchOnDialogType = type
      if (record) this.dialogForm = _.cloneDeep(record)
      this.dialogVisible = true
    },
    handleOk() {
      this.$refs.dialogForm.validate(async valid => {
        if (valid) {
          const isCreated = this.pitchOnDialogType === 1
          this.dialogConfirmLoading = true
          try {
            const { code } = isCreated ? await api.createdPrizeType(this.dialogForm) : await api.updatePrizeType(this.dialogForm)
            if (code === '000000') {
              this.$notification.success({
              message: '操作成功',
              description: `奖品类型【${this.dialogForm.name}】已成功${isCreated ? '创建' : '更新'}` })
              this.MIXINHandleRefreshTable(this.fetchOriginList)
              this.dialogVisible = false
            }
            this.dialogConfirmLoading = false
          } catch {
            this.dialogConfirmLoading = false
          }
        } else {
          return false
        }
      })
    },
    async confirmDelete(record) {
      const { code } = await api.deletePrizeType(record)
      if (code === '000000') {
        this.$notification.success({
        message: '操作成功',
        description: `奖品类型【${record.name}】已成功删除` })
        this.MIXINHandleRefreshTable(this.fetchOriginList)
      }
    },
    async fetchOriginList() {
      const DefaultPagination = { page: 1, per_page: 10, total: 0 }
      try {
        const { code, data } = await api.fetchPrizeTypeList(this.MIXIXGetTableTransferAllParams())
        const isSucceed = code === '000000'
        return {
          list: isSucceed ? data.category : [],
          pagination: isSucceed ? data.pagination : { ...DefaultPagination }
        }
      } catch {
        return { list: [], pagination: { ...DefaultPagination } }
      }
    },
    handleTopSearchSubmit() {
      this.MIXINSaveTopSearchParamsToStorage(() => this.MIXINHandlePageChange(this.fetchOriginList, 1))
    },
    handleTopSearchClear() {
      this.MIXINClearTopSearchParams(() => this.MIXINHandlePageChange(this.fetchOriginList, 1))
    },
    handleTableChange({ current, pageSize }) {
      this.MIXINHandlePageChange(this.fetchOriginList, current, pageSize)
    },
  },
  created() {
    this.MIXINInit({
      tableColumns: tableColumns,
      topSearchParams: { name: '' },
      afterInit: () => this.MIXINHandlePageChange(this.fetchOriginList, 1)
    })
  },
}
</script>

<style scoped lang="less">
@import url(../style/public.less);
</style>
